import React from 'react';
import styles from './styles.module.css';

export default () => {
    return (
        <div className={styles.netflixIntro}>
            <div className={styles.n} letter="N">
                <div className={styles.helper1}>
                    <div className={styles.effectBrush}>
                    <span className={styles.fur31}></span>
                    <span className={styles.fur30}></span>
                    <span className={styles.fur29}></span>
                    <span className={styles.fur28}></span>
                    <span className={styles.fur27}></span>
                    <span className={styles.fur26}></span>
                    <span className={styles.fur25}></span>
                    <span className={styles.fur24}></span>
                    <span className={styles.fur23}></span>
                    <span className={styles.fur22}></span>
                    <span className={styles.fur21}></span>
                    <span className={styles.fur20}></span>
                    <span className={styles.fur19}></span>
                    <span className={styles.fur18}></span>
                    <span className={styles.fur17}></span>
                    <span className={styles.fur16}></span>
                    <span className={styles.fur15}></span>
                    <span className={styles.fur14}></span>
                    <span className={styles.fur13}></span>
                    <span className={styles.fur12}></span>
                    <span className={styles.fur11}></span>
                    <span className={styles.fur10}></span>
                    <span className={styles.fur9}></span>
                    <span className={styles.fur8}></span>
                    <span className={styles.fur7}></span>
                    <span className={styles.fur6}></span>
                    <span className={styles.fur5}></span>
                    <span className={styles.fur4}></span>
                    <span className={styles.fur3}></span>
                    <span className={styles.fur2}></span>
                    <span className={styles.fur1}></span>
                </div>
                <div className={styles.effectLumieres}>
                    <span className={styles.lamp1}></span>
                    <span className={styles.lamp2}></span>
                    <span className={styles.lamp3}></span>
                    <span className={styles.lamp4}></span>
                    <span className={styles.lamp5}></span>
                    <span className={styles.lamp6}></span>
                    <span className={styles.lamp7}></span>
                    <span className={styles.lamp8}></span>
                    <span className={styles.lamp9}></span>
                    <span className={styles.lamp10}></span>
                    <span className={styles.lamp11}></span>
                    <span className={styles.lamp12}></span>
                    <span className={styles.lamp13}></span>
                    <span className={styles.lamp14}></span>
                    <span className={styles.lamp15}></span>
                    <span className={styles.lamp16}></span>
                    <span className={styles.lamp17}></span>
                    <span className={styles.lamp18}></span>
                    <span className={styles.lamp19}></span>
                    <span className={styles.lamp20}></span>
                    <span className={styles.lamp21}></span>
                    <span className={styles.lamp22}></span>
                    <span className={styles.lamp23}></span>
                    <span className={styles.lamp24}></span>
                    <span className={styles.lamp25}></span>
                    <span className={styles.lamp26}></span>
                    <span className={styles.lamp27}></span>
                    <span className={styles.lamp28}></span>
                </div>
                </div>
                <div className={styles.helper2}>
                    <div className={styles.effectBrush}>
                    <span className={styles.fur31}></span>
                    <span className={styles.fur30}></span>
                    <span className={styles.fur29}></span>
                    <span className={styles.fur28}></span>
                    <span className={styles.fur27}></span>
                    <span className={styles.fur26}></span>
                    <span className={styles.fur25}></span>
                    <span className={styles.fur24}></span>
                    <span className={styles.fur23}></span>
                    <span className={styles.fur22}></span>
                    <span className={styles.fur21}></span>
                    <span className={styles.fur20}></span>
                    <span className={styles.fur19}></span>
                    <span className={styles.fur18}></span>
                    <span className={styles.fur17}></span>
                    <span className={styles.fur16}></span>
                    <span className={styles.fur15}></span>
                    <span className={styles.fur14}></span>
                    <span className={styles.fur13}></span>
                    <span className={styles.fur12}></span>
                    <span className={styles.fur11}></span>
                    <span className={styles.fur10}></span>
                    <span className={styles.fur9}></span>
                    <span className={styles.fur8}></span>
                    <span className={styles.fur7}></span>
                    <span className={styles.fur6}></span>
                    <span className={styles.fur5}></span>
                    <span className={styles.fur4}></span>
                    <span className={styles.fur3}></span>
                    <span className={styles.fur2}></span>
                    <span className={styles.fur1}></span>
                    </div>
                </div>
                <div className={styles.helper3}>
                    <div className={styles.effectBrush}>
                    <span className={styles.fur31}></span>
                    <span className={styles.fur30}></span>
                    <span className={styles.fur29}></span>
                    <span className={styles.fur28}></span>
                    <span className={styles.fur27}></span>
                    <span className={styles.fur26}></span>
                    <span className={styles.fur25}></span>
                    <span className={styles.fur24}></span>
                    <span className={styles.fur23}></span>
                    <span className={styles.fur22}></span>
                    <span className={styles.fur21}></span>
                    <span className={styles.fur20}></span>
                    <span className={styles.fur19}></span>
                    <span className={styles.fur18}></span>
                    <span className={styles.fur17}></span>
                    <span className={styles.fur16}></span>
                    <span className={styles.fur15}></span>
                    <span className={styles.fur14}></span>
                    <span className={styles.fur13}></span>
                    <span className={styles.fur12}></span>
                    <span className={styles.fur11}></span>
                    <span className={styles.fur10}></span>
                    <span className={styles.fur9}></span>
                    <span className={styles.fur8}></span>
                    <span className={styles.fur7}></span>
                    <span className={styles.fur6}></span>
                    <span className={styles.fur5}></span>
                    <span className={styles.fur4}></span>
                    <span className={styles.fur3}></span>
                    <span className={styles.fur2}></span>
                    <span className={styles.fur1}></span>
                    </div>
                </div>
                <div className={styles.helper4}>
                    <div className={styles.effectBrush}>
                        <span className={styles.fur31}></span>
                        <span className={styles.fur30}></span>
                        <span className={styles.fur29}></span>
                        <span className={styles.fur28}></span>
                        <span className={styles.fur27}></span>
                        <span className={styles.fur26}></span>
                        <span className={styles.fur25}></span>
                        <span className={styles.fur24}></span>
                        <span className={styles.fur23}></span>
                        <span className={styles.fur22}></span>
                        <span className={styles.fur21}></span>
                        <span className={styles.fur20}></span>
                        <span className={styles.fur19}></span>
                        <span className={styles.fur18}></span>
                        <span className={styles.fur17}></span>
                        <span className={styles.fur16}></span>
                        <span className={styles.fur15}></span>
                        <span className={styles.fur14}></span>
                        <span className={styles.fur13}></span>
                        <span className={styles.fur12}></span>
                        <span className={styles.fur11}></span>
                        <span className={styles.fur10}></span>
                        <span className={styles.fur9}></span>
                        <span className={styles.fur8}></span>
                        <span className={styles.fur7}></span>
                        <span className={styles.fur6}></span>
                        <span className={styles.fur5}></span>
                        <span className={styles.fur4}></span>
                        <span className={styles.fur3}></span>
                        <span className={styles.fur2}></span>
                        <span className={styles.fur1}></span>
                    </div>
                </div>
            </div>
        </div>
    )
}